function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
import compose from './compose';
import defaultGlobals from '../styles/defaultGlobals';
import getDisplayName from './getDisplayName';
import IPT from 'react-immutable-proptypes';
import jss, { getDynamicStyles, SheetsManager } from './jss';
import React from 'react';
import RPT from 'prop-types';
import { Map, Seq } from 'immutable';
var dynamicStylesNs = Math.random();
var managersCounter = 0;
/**
 * Converts JS object to immutable ordered map or list
 *
 * @param  {Object} js - JavaScript object
 * @return {OrderedMap|List} - immutable ordered map
 */

function fromJS(js) {
  if (_typeof(js) !== 'object' || js === null) {
    return js;
  }
  return Array.isArray(js) ? Seq(js).map(fromJS).toList() : Seq(js).map(fromJS).toOrderedMap();
}

/**
 * Wrap a Component into a JSS Container Component.
 *
 * @param {Object|Function} stylesOrCreator -
 * @param {Component} InnerComponent -
 * @param {Object} [sheetOptions = {}] -
 *
 * @return {Component} -
 */
export default (function (stylesOrCreator, InnerComponent) {
  var sheetOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var themingEnabled = typeof stylesOrCreator === 'function';
  var displayName = getDisplayName(InnerComponent);
  var defaultClassNamePrefix = process.env.NODE_ENV === 'production' ? undefined : "".concat(displayName, "-");
  var managerId = managersCounter++;
  var manager = new SheetsManager();
  var defaultProps = _objectSpread({}, InnerComponent.defaultProps);
  delete defaultProps.classes;
  var Jss = /*#__PURE__*/
  function (_React$Component) {
    _inherits(Jss, _React$Component);
    function Jss(props, context) {
      var _this;
      _classCallCheck(this, Jss);
      _this = _possibleConstructorReturn(this, _getPrototypeOf(Jss).call(this, props, context));
      var theme = _this.getTheme(context);
      _this.state = _this.createState({
        theme: theme
      }, props);
      _this.manage(_this.state);
      return _this;
    }
    _createClass(Jss, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        var dynamicSheet = this.state.dynamicSheet;
        if (dynamicSheet) {
          dynamicSheet.update(this.props);
        }
        if (prevState.dynamicSheet !== dynamicSheet) {
          this.jss.removeStyleSheet(prevState.dynamicSheet);
        }
        if (process.env.STORYBOOK_LIVE_STYLE_RELOAD) {
          var theme = this.getTheme(this.context);
          var oldThemeId = this.state.theme.get('id');
          if (themingEnabled && oldThemeId !== theme.get('id')) {
            var newState = this.createState({
              theme: theme
            }, this.props);
            this.manage(newState);
            this.manager.unmanage(oldThemeId); // eslint-disable-next-line react/no-did-update-set-state

            this.setState(newState);
          }
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var _this$state = this.state,
          dynamicSheet = _this$state.dynamicSheet,
          theme = _this$state.theme;
        this.manager.unmanage(theme.get('id'));
        if (dynamicSheet) {
          dynamicSheet.detach();
        }
      }
    }, {
      key: "getTheme",
      value: function getTheme(_ref) {
        var themeStyle = _ref.themeStyle;
        return themeStyle || Map();
      }
    }, {
      key: "getStyleRoot",
      value: function getStyleRoot() {
        if (!InnerComponent.styleRoot) {
          throw new TypeError("Property styleRoot is required for ".concat(displayName, " component"));
        }
        return InnerComponent.styleRoot;
      }
    }, {
      key: "resolveStyleObject",
      value: function resolveStyleObject() {
        var stylesOrCreator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var globals = arguments.length > 1 ? arguments[1] : undefined;
        var styles = typeof stylesOrCreator === 'function' ? stylesOrCreator(globals) : stylesOrCreator;
        return fromJS(styles);
      }
    }, {
      key: "createState",
      value: function createState(_ref2, _ref3) {
        var theme = _ref2.theme,
          dynamicSheet = _ref2.dynamicSheet;
        var userClasses = _ref3.classes;
        var _this$context = this.context,
          contextSheetOptions = _this$context.sheetOptions,
          includeQaClassNames = _this$context.includeQaClassNames;
        if (contextSheetOptions && contextSheetOptions.disableStylesGeneration) {
          return {
            theme: theme,
            dynamicSheet: dynamicSheet,
            classes: {}
          };
        }
        var themeId = theme.get('id');
        var classNamePrefix = defaultClassNamePrefix;
        var staticSheet = this.manager.get(themeId);
        if (contextSheetOptions && contextSheetOptions.classNamePrefix) {
          classNamePrefix = contextSheetOptions.classNamePrefix + classNamePrefix;
        }
        if (!staticSheet) {
          var globals = (theme.get('globals') || defaultGlobals).toJS();
          var baseStyles = this.resolveStyleObject(stylesOrCreator, globals);
          var themeStyles = this.resolveStyleObject(theme.get(this.getStyleRoot()), globals);
          var styles = baseStyles.mergeDeep(themeStyles).toJS();
          staticSheet = this.jss.createStyleSheet(styles, _objectSpread({}, sheetOptions, contextSheetOptions, {
            meta: "".concat(displayName, ", ").concat(themingEnabled ? 'Themed' : 'Unthemed', ", Static"),
            classNamePrefix: classNamePrefix
          }));
          this.manager.add(themeId, staticSheet);
          staticSheet[dynamicStylesNs] = getDynamicStyles(styles);
        }
        var dynamicStyles = staticSheet[dynamicStylesNs];
        if (dynamicStyles) {
          dynamicSheet = this.jss.createStyleSheet(dynamicStyles, _objectSpread({}, sheetOptions, contextSheetOptions, {
            meta: "".concat(displayName, ", ").concat(themingEnabled ? 'Themed' : 'Unthemed', ", Dynamic"),
            classNamePrefix: classNamePrefix,
            link: true
          }));
        }
        var defaultClasses = InnerComponent.defaultProps ? InnerComponent.defaultProps.classes : undefined;
        var jssClasses = dynamicSheet ? compose(staticSheet.classes, dynamicSheet.classes) : staticSheet.classes;
        var classes = _objectSpread({}, defaultClasses, jssClasses);
        if (userClasses) {
          classes = Object.keys(classes).reduce(function (acc, key) {
            return _objectSpread({}, acc, _defineProperty({}, key, userClasses[key] ? [classes[key], userClasses[key]].join(' ') : classes[key]));
          }, {});
        }
        if (includeQaClassNames || sheetOptions.includeQaClassNames) {
          for (var key in staticSheet.classes) {
            if (staticSheet.classes.hasOwnProperty(key)) {
              var noDuplicates = new RegExp(" id_".concat(classNamePrefix).concat(key), 'g');
              var newClassList = staticSheet.classes[key].replace(noDuplicates, '');
              classes[key] = "".concat(newClassList, " id_").concat(classNamePrefix).concat(key);
            }
          }
        }
        return {
          theme: theme,
          dynamicSheet: dynamicSheet,
          classes: classes
        };
      }
    }, {
      key: "manage",
      value: function manage(_ref4) {
        var dynamicSheet = _ref4.dynamicSheet,
          theme = _ref4.theme;
        var contextSheetOptions = this.context.sheetOptions;
        if (contextSheetOptions && contextSheetOptions.disableStylesGeneration) {
          return;
        }
        var registry = this.context.sheetsRegistry;
        var staticSheet = this.manager.manage(theme.get('id'));
        if (registry) {
          registry.add(staticSheet);
        }
        if (dynamicSheet) {
          dynamicSheet.update(this.props).attach();
          if (registry) {
            registry.add(dynamicSheet);
          }
        }
      }
    }, {
      key: "render",
      value: function render() {
        var innerRef = this.props.innerRef;
        var _this$state2 = this.state,
          classes = _this$state2.classes,
          theme = _this$state2.theme;
        var globals = (theme.get('globals') || defaultGlobals).toJS();
        return React.createElement(InnerComponent, _extends({}, this.props, {
          ref: innerRef,
          classes: classes,
          globals: globals
        }));
      }
    }, {
      key: "jss",
      get: function get() {
        return this.context.jss || sheetOptions.jss || jss;
      }
    }, {
      key: "manager",
      get: function get() {
        var managers = this.context.managers;
        if (managers) {
          if (!managers[managerId]) {
            managers[managerId] = new SheetsManager();
          }
          return managers[managerId];
        }
        return manager;
      }
    }]);
    return Jss;
  }(React.Component);
  _defineProperty(Jss, "displayName", "Jss(".concat(displayName, ")"));
  _defineProperty(Jss, "InnerComponent", InnerComponent);
  _defineProperty(Jss, "contextTypes", {
    jss: RPT.shape({
      options: RPT.shape({
        createGenerateClassName: RPT.func.isRequired
      }).isRequired,
      createStyleSheet: RPT.func.isRequired,
      removeStyleSheet: RPT.func.isRequired
    }),
    managers: RPT.object,
    sheetOptions: RPT.object,
    sheetsRegistry: RPT.shape({
      add: RPT.func.isRequired
    }),
    themeStyle: IPT.map,
    includeQaClassNames: RPT.bool
  });
  _defineProperty(Jss, "defaultProps", defaultProps);
  return Jss;
});